import { createRoutine } from 'redux-saga-routines';
import { createSlice } from 'utils/@reduxjs/toolkit';
import { useInjectReducer, useInjectSaga } from 'utils/redux-injectors';

interface CommonSate {
  loading: boolean;
  success: boolean;
  error: boolean;
}
export const initialState: CommonSate = {
  loading: false,
  error: false,
  success: false,
};
export const slice = createSlice({
  name: 'common',
  initialState,
  reducers: {
    fetchLoadingPage(state) {
      state.loading = true;
    },
    fetchHiddenLoadingPage(state) {
      state.loading = false;
    },
  },
  extraReducers: {},
});
export const { actions: commonActions } = slice;
export const useCommonSlice = () => {
  useInjectReducer({ key: slice.name, reducer: slice.reducer });
  return { actions: slice.actions };
};
